import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=2e24a0fe&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=2e24a0fe&prod&lang=css&"
import style1 from "./Contacts.vue?vue&type=style&index=1&id=2e24a0fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports